import React, { useEffect, useState } from 'react';
import { APIURL } from '../../../configApi/apiConfig';
import axios from '../../../configApi/axiosConfig';
import { PhoneIcon, UserIcon, CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { SaveGestion } from '../SaveGestion/SaveGestion';


export function CardVerificacionTelefonica({ sCre_SolicitudWeb, estado = 11, estadoGestion, data: parentData }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showSaveGestion, setShowSaveGestion] = useState(false);
    const [telefonoSeleccionado, setTelefonoSeleccionado] = useState('');

    useEffect(() => {
        if (!sCre_SolicitudWeb) return;
        setLoading(true);
        setError('');
        axios.get(APIURL.get_cre_verificacion_telefonica_maestro(sCre_SolicitudWeb, estado))
            .then(res => {
                if (Array.isArray(res.data)) {
                    setData(res.data);
                } else if (res.data && Array.isArray(res.data.data)) {
                    setData(res.data.data);
                } else {
                    setData([]);
                }
            })
            .catch(() => setError('Error al cargar verificación telefónica'))
            .finally(() => setLoading(false));
    }, [sCre_SolicitudWeb, estado]);

    if (!sCre_SolicitudWeb) return null;

    return (
        <div className="my-4">
            <h3 className="text-md font-bold text-blue-800 mb-2 flex items-center gap-2">
                <PhoneIcon className="w-5 h-5 text-blue-600" /> Verificación Telefónica (Cards)
            </h3>
            {loading && <div className="text-blue-600 font-bold mb-2">Cargando...</div>}
            {error && <div className="text-red-600 font-bold mb-2">{error}</div>}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {data.length === 0 && !loading && !error && (
                    <div className="col-span-full text-slate-500 italic">No hay registros de verificación telefónica.</div>
                )}
                {data.map((item, idx) => (
                    <div key={idx} className="bg-white border border-blue-200 rounded-xl shadow p-4 flex flex-col gap-2 hover:shadow-lg transition-shadow">
                        <div className="flex items-center gap-2 justify-between">
                            <div className="flex items-center gap-2">
                                <span className="font-bold text-blue-900 text-lg">{item.telefono || '-'}</span>
                                {item.estadoGestns === 'VALIDADO' ? (
                                    <CheckIcon className="w-5 h-5 text-green-500" title="Validado" />
                                ) : item.estadoGestns === 'RECHAZADO' ? (
                                    <XMarkIcon className="w-5 h-5 text-red-500" title="Rechazado" />
                                ) : null}
                            </div>
                        </div>
                        <div className="text-xs text-slate-600">
                            <span className="font-semibold">Observación:</span> {item.observacion || '-'}
                        </div>
                        <div className="flex gap-2 text-xs">
                            <span className="bg-blue-100 text-blue-700 px-2 py-0.5 rounded font-bold">{item.estadoOrigenTelefonica || '-'}</span>
                        </div>
                        <button
                            type="button"
                            className="flex items-center justify-center p-2 bg-green-100 hover:bg-green-200 rounded-full shadow-sm transition-all duration-200"
                            title="Registrar gestión para este teléfono"
                            onClick={() => {
                                setTelefonoSeleccionado(item.telefono);
                                setShowSaveGestion(true);
                            }}
                        >
                            <PhoneIcon className="w-5 h-5 text-blue-500" />
                        </button>
                    </div>
                ))}
            </div>
        {/* Modal SaveGestion para registrar gestión con el teléfono seleccionado */}
        <SaveGestion
            isOpen={showSaveGestion}
            onClose={() => setShowSaveGestion(false)}
            estadoGestion={estadoGestion}
            datosCobranza={{ Celular: telefonoSeleccionado }}
            data={parentData}
        />
    </div>
    );
}
